import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { BzgModalService } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { UserJobsService } from 'app/scheduler/user-Jobs/user-jobs.service';
import { I18nService } from 'i18n/i18n.service';
import { IJob } from '../IJob';
import { ShowToastService } from 'app/shared/services/showToast.service';
import { DateUtil } from 'app/core/utils/DateUtil';

@Component({
  selector: 'job-settings-readonly',
  templateUrl: 'job-settings-readonly.component.html',
  styleUrls: ['job-settings-readonly.component.scss']
})
export class JobSettingsReadOnlyComponent implements OnChanges, OnInit {

  @Input() applyDisabled = false;
  @Input() currentJob: IJob;
  @Input() jobStates: { [key: string]: { originalNextRuntimeDate: Date, nextRuntimeDate: Date } } = {};
  @Input() isDevelopment: boolean;
  @Output() saveJob = new EventEmitter<IJob>();
  @Output() cancel = new EventEmitter();
  @Output() reset = new EventEmitter();

  public showReset: boolean = false;
  public dateMax: Date = new Date();

  constructor(private _modalService: BzgModalService,
    private _userJobService: UserJobsService,
    private _showToastService: ShowToastService,
    private _i18nService: I18nService) {
    this.dateMax.setFullYear(this.dateMax.getFullYear() + 10);
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (!this.jobStates[this.currentJob.id]) {
      this.jobStates[this.currentJob.id] = {
        originalNextRuntimeDate: new Date(this.currentJob.nextRuntime),
        nextRuntimeDate: new Date(DateUtil.convertFromLocalToUTCReturnDate(this.currentJob.nextRuntime))
      };
    }

    if (this.currentJob) {
      this.getStatusReset();
    }
  }

  public setJobNow() {
    this.currentJob.enabled = true;

    const newDate = DateUtil.convertFromLocalToUTCReturnDate(new Date());
    this.jobStates[this.currentJob.id].nextRuntimeDate = new Date(newDate);


    this.jobStates[this.currentJob.guid].nextRuntimeDate = DateUtil.convertFromLocalToUTCReturnDate(new Date());
  }

  public applyChanges() {
    if (this.jobStates[this.currentJob.id]) {
      this.currentJob.nextRuntime = DateUtil.returnDateToSave(this.jobStates[this.currentJob.id].nextRuntimeDate);
      if (this.currentJob.schedules) {
        this.currentJob.schedules.forEach(schedule => {
          schedule.nextRunTime = this.currentJob.nextRuntime;
        });
      }
    }

    this.saveJob.emit(this.currentJob);
    this.getStatusReset();
  }

  public cancelChanges() {
    // Restaurar desde el estado original
    const originalDate = this.jobStates[this.currentJob.id].originalNextRuntimeDate;
    this.jobStates[this.currentJob.id].nextRuntimeDate = new Date(originalDate);
    this.currentJob.nextRuntime = originalDate;
    this.cancel.emit();
  }

  public resetJob() {
    const title = `${this._i18nService.instant('GLOBAL.RESET')} - ${this.currentJob.name}`
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message: 'GLOBAL.CONFIRM_RESET', button: 'GLOBAL.RESET' }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        this._userJobService.resetStatus(this.currentJob.guid).subscribe((response) => {
          if (response) {
            this.reset.emit();
            this.getStatusReset();
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
          }
        });
      }
    });
  }

  public getStatusReset() {
    if (this.currentJob.guid) {
      this._userJobService.getStatusReset(this.currentJob.guid).subscribe((response) => {
        this.showReset = response;
      });
    }
  }

  public onDateChange(newDate: Date) {
    if (newDate && this.currentJob?.id) {
      this.jobStates[this.currentJob.id].nextRuntimeDate = new Date(newDate);
    }
  }

  public hiddenNextRunTime(): boolean {
    if (this.currentJob.jobType === 'Wait') {
      return !this.currentJob.disableEditJob;
    }
    return true;
  }
}
